import {
  ACTIVATE_JOB_TYPE,
  DESTROY_JOB_TYPE,
  FETCH_JOB_TYPE,
  JobTypeActions,
  RECEIVE_JOB_TYPE,
  RECEIVE_JOB_TYPES,
  REMOVE_JOB_TYPE,
  RESET_JOB_TYPE,
  SET_JOB_TYPE_LOADED,
} from "common/reducers/jobType.actions";
import { Map, Record, List } from "immutable";
import { IJobTypeData, JobTypeRecord, jobTypeFromJSON } from "common/records/JobType";
import { RootActions, RootState } from "common/reducers";
import { fetch, loaded, receive, reset } from "common/reducers/Utils";
import { reducer as idsManagementReducer } from "common/reducers/idsManagement.reducer";
import { IdsManagementActions } from "common/reducers/idsManagement.actions";

export const JobTypeStateRecord = Record({
  byId: Map<string | number, JobTypeRecord>(),
  lastSavedById: Map<string | number, JobTypeRecord>(),
});

export const initialState = JobTypeStateRecord();

export type JobTypeState = typeof initialState;

export const model = "jobTypes";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case FETCH_JOB_TYPE:
      return fetch(state, model, jobTypeFromJSON({ id: action.payload.jobTypeId })) as RootState;

    case RECEIVE_JOB_TYPES:
      const jobTypes = List(action.payload.jobTypes);
      jobTypes.forEach((jobType) => {
        state = reducer(state, JobTypeActions.receiveJobType(jobType));
      });

      const activeIds = jobTypes
        .filter((jobType) => Boolean(jobType.org_job_object_link))
        .sortBy((jobType) => jobType.org_job_object_link?.sort_order)
        .map((jobType) => jobType.id);
      const availableIds = jobTypes.filter((jobType) => !jobType.org_job_object_link).map((jobType) => jobType.id);

      state = idsManagementReducer(state, IdsManagementActions.receiveModel(model + ".active", activeIds));
      state = idsManagementReducer(state, IdsManagementActions.receiveModel(model + ".available", availableIds));

      return state.setIn([model, "loading"], false);

    case RECEIVE_JOB_TYPE:
      const jobTypeRecord = jobTypeFromJSON(action.payload.jobType);
      state = receive(state, model, jobTypeRecord) as RootState;

      if (action.payload.pushToList) {
        state = idsManagementReducer(state, IdsManagementActions.pushId(jobTypeRecord.id, model + ".active"));
      }
      return state;

    case RESET_JOB_TYPE:
      return reset(state, model, action.payload.jobTypeId) as RootState;

    case SET_JOB_TYPE_LOADED:
      return loaded(state, model, action.payload.jobTypeId) as RootState;

    case DESTROY_JOB_TYPE:
      state = idsManagementReducer(
        state,
        IdsManagementActions.removeId(action.payload.jobTypeId, model + ".available"),
      );

      return state
        .deleteIn([model, "byId", action.payload.jobTypeId])
        .deleteIn([model, "lastSavedById", action.payload.jobTypeId]);

    case REMOVE_JOB_TYPE: {
      state = idsManagementReducer(state, IdsManagementActions.pushId(action.payload.jobTypeId, model + ".available"));
      state = idsManagementReducer(state, IdsManagementActions.removeId(action.payload.jobTypeId, model + ".active"));

      return state.updateIn([model, "byId", action.payload.jobTypeId], (jobType: JobTypeRecord) =>
        jobType.set("org_job_object_link", null),
      );
    }
    case ACTIVATE_JOB_TYPE: {
      state = idsManagementReducer(state, IdsManagementActions.pushId(action.payload.jobTypeId, model + ".active"));
      state = idsManagementReducer(
        state,
        IdsManagementActions.removeId(action.payload.jobTypeId, model + ".available"),
      );

      return state;
    }

    default:
      return state;
  }
};
